export default "__VITE_ASSET__Bnqc$rWD__"